























import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { ImageLayer } from "@/model/document2/page/surface/design/layer/imageLayer";
import { MathHelper } from '@/helper/mathHelper';

@Component({
    components: {
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class ImageOpacityController extends Vue 
{
    @Prop() layer! : ImageLayer;

    private static readonly WHITE_TRANSPARENT_ON = "白色透明化ON";
    private static readonly WHITE_TRANSPARENT_OFF = "白色透明化OFF";

    private get opacity()
    { 
        return this.layer.opacity;
    }
    private set opacity(opacity)
    {
        this.changeLayerProperty("opacity", Number(opacity), false, false);
    }

    private onOpacityChanged()
    {
        this.changeLayerProperty("opacity", this.layer.opacity, true, false);
    }

    private get opacityText()
    {
        return this.opacity.toFixed() + "%";
    }

    private get whiteTransparentText()
    {
        return this.layer.whiteTransparent ? ImageOpacityController.WHITE_TRANSPARENT_ON : ImageOpacityController.WHITE_TRANSPARENT_OFF;
    }

    private changeWhiteTransparent()
    {
        this.changeLayerProperty("whiteTransparent", !this.layer.whiteTransparent, true, true);
    }

    private changeLayerProperty(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        this.$emit("changeLayerProperty", propertyName, value, isFinish, isOnce);
    }
}
